import { gtagLineEvent } from "@/utils/gtag";

const LINE_URL = "https://lin.ee/T5fqaOx";
const GTAG_EVENT = "YAMEBI_1_LINE友達追加_ページ最下部";

export default function CompanySection() {
  return (
    <footer className="bg-[#F5F5F0] py-16 px-6">
      <div className="max-w-3xl mx-auto">
        {/* 最終CTA */}
        <div className="bg-[#1a1a1a] rounded-2xl p-10 text-center mb-12">
          <img
            src="https://static.readdy.ai/image/b17b44323c7eb3fa784eb391778099fd/364f60d3363b88dfbdfabe6d3242f52a.svg"
            alt="YAMEBI"
            className="h-8 w-auto object-contain mx-auto mb-4 opacity-80"
          />
          <p className="text-white text-lg font-black mb-6">
            まずはLINEで仕組みを確認してみてください
          </p>
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => { e.preventDefault(); gtagLineEvent(LINE_URL, GTAG_EVENT); }}
            className="whitespace-nowrap inline-flex items-center gap-2 bg-[#00B900] hover:bg-[#009900] text-white font-bold text-base py-4 px-10 rounded-full transition-all cursor-pointer hover:scale-105 shadow-[0_8px_25px_rgba(0,185,0,0.5)] hover:shadow-[0_12px_35px_rgba(0,185,0,0.65)]"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-line-fill text-xl"></i>
            </span>
            公式LINEを友だち追加する
          </a>
          <p className="text-white/50 text-xs mt-2">まずはLINEで内容を確認する</p>
        </div>

        {/* 会社情報 */}
        <div className="mb-8">
          <h3 className="font-bold text-[#1a1a1a] text-sm mb-4 text-center">運営会社</h3>
          <div className="bg-white rounded-xl border border-gray-200 p-6 max-w-md mx-auto">
            <dl className="space-y-2">
              <div className="flex gap-3 text-sm">
                <dt className="text-[#999] font-medium w-16 flex-shrink-0">社名</dt>
                <dd className="text-[#333]">株式会社Leagence</dd>
              </div>
              <div className="flex gap-3 text-sm">
                <dt className="text-[#999] font-medium w-16 flex-shrink-0">住所</dt>
                <dd className="text-[#333]">東京都渋谷区道玄坂1-10-8 渋谷道玄坂東急ビル2F-C</dd>
              </div>
              <div className="flex gap-3 text-sm">
                <dt className="text-[#999] font-medium w-16 flex-shrink-0">設立</dt>
                <dd className="text-[#333]">2019年11月</dd>
              </div>
              <div className="flex gap-3 text-sm">
                <dt className="text-[#999] font-medium w-16 flex-shrink-0">代表</dt>
                <dd className="text-[#333]">旦 将志</dd>
              </div>
            </dl>
          </div>
        </div>

        <div className="flex justify-center gap-6 text-xs text-[#999] border-t border-gray-200 pt-6">
          <a
            href="https://leagence.co.jp/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#666] transition-colors cursor-pointer underline"
          >
            プライバシーポリシー
          </a>
          <span>© 2026 株式会社Leagence</span>
        </div>
      </div>
    </footer>
  );
}
